// React
import { connect } from 'react-redux';
// Components
import NivelatTutorialBox from './NivelatTutorialBox';
// Actions
import { injectIntl } from 'react-intl';

const mapStateToProps = ({ partnerReducer }, { intl: { formatMessage } }) => {
  const covidTitle = formatMessage({
    id: 'tipsCovid.COVID19',
  });
  const covidDescription = formatMessage({
    id: 'tipsCovid.covidDescription',
  });
  const covidMoreInfo = formatMessage({
    id: 'tipsCovid.covidMoreInfo',
  });
  const covidTipsButton = formatMessage({
    id: 'tipsCovid.CovidTipsButton',
  });
  const profile = partnerReducer.profile;
  return {
    profile,
    covidTitle,
    covidDescription,
    covidMoreInfo,
    covidTipsButton,
  };
};
const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NivelatTutorialBox),
);
